import React from 'react';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className='not-found'> Page Not Found :{"("} </div>
  )
}

export default NotFound